var config = require('../variants/' + BUILD_VARIANT + '/config.js').default;

export default [
  {
    icon: 'bubble_chart',
    title: 'Chat to a Professional',
    subtitle: 'Have a personal conversation with a ' + config.practitioner.type,
    img: require('../variants/' + BUILD_VARIANT + '/img/icons/new_chat_main_icon.png'),
    img_menu: require('../static/img/icons/dashboard/sml_chat_main_icon.png'),
    route: {name: 'authenticated.chat'},
    dashboard: true,
    active: config.modules.chat
  },
  {
    icon: 'bubble_chart',
    title: 'Inbox',
    subtitle: 'Your past chats, all in one place',
    img: require('../variants/' + BUILD_VARIANT + '/img/icons/new_inbox_icon.png'),
    img_menu: require('../static/img/icons/dashboard/sml_inbox_icon.png'),
    route: {name: 'authenticated.inbox'},
    dashboard: true,
    active: config.modules.inbox
  },
  {
    icon: 'bubble_chart',
    title: 'Medical Information',
    subtitle: 'Your medical information securely stored in one place',
    img: require('../variants/' + BUILD_VARIANT + '/img/icons/new_medical_info_icon.png'),
    img_menu: require('../static/img/icons/dashboard/sml_medical_info_icon.png'),
    route: {name: 'authenticated.medical'},
    dashboard: true,
    active: config.modules.medical
  },
  {
    icon: 'bubble_chart',
    title: 'Symptom Checker',
    subtitle: 'Designed to help you understand what your medical symptoms could mean',
    img: require('../variants/' + BUILD_VARIANT + '/img/icons/new_sympton_icon.png'),
    img_menu: require('../static/img/icons/dashboard/sml_sympton_icon.png'),
    route: {name: 'authenticated.symptom'},
    dashboard: true,
    active: config.modules.symptom
  },
  {
    icon: 'bubble_chart',
    title: 'Health Tips',
    subtitle: 'Lead a healthier life with these must know tips',
    img: require('../variants/' + BUILD_VARIANT + '/img/icons/new_health_tips_icon.png'),
    img_menu: require('../static/img/icons/dashboard/sml_health_tips_icon.png'),
    route: {name: 'authenticated.healthtips'},
    dashboard: true,
    active: config.modules.healthtips
  },
  {
    icon: 'bubble_chart',
    title: 'Coronavirus',
    subtitle: 'Everything you need to know',
    img: require('../variants/' + BUILD_VARIANT + '/img/icons/new_health_tips_icon.png'),
    img_menu: require('../static/img/icons/dashboard/sml_health_tips_icon.png'),
    route: {name: 'authenticated.coronavirus'},
    dashboard: true,
    active: config.modules.coronavirus
  },
  {
    icon: 'bubble_chart',
    title: 'Legal Documents',
    subtitle: 'Request legal documents',
    img: require('../variants/' + BUILD_VARIANT + '/img/icons/new_legal_documents_icon.png'),
    img_menu: require('../static/img/icons/dashboard/sml_legal_documents_icon.png'),
    route: {name: 'authenticated.documents'},
    dashboard: true,
    active: config.modules.documents
  },
  {
    icon: 'bubble_chart',
    title: 'Share to Win!',
    subtitle: 'Share this app with 5 or more of your friends and family to stand a chance to win a new Toyota Corolla',
    img: require('../variants/' + BUILD_VARIANT + '/img/icons/share_icon.png'),
    img_menu: require('../static/img/icons/dashboard/sml_legal_documents_icon.png'),
    dashboard: true,
    active: config.modules.share,
    share: true
  },
  {
    divider: true
  },
  {
    icon: 'bubble_chart',
    title: 'Profile',
    img: require('../variants/' + BUILD_VARIANT + '/img/icons/new_profile_icon.png'),
    img_menu: require('../static/img/icons/dashboard/sml_profile_icon.png'),
    route: {name: 'authenticated.profile'},
    dashboard: false,
    active: config.modules.profile
  },
  {
    icon: 'bubble_chart',
    title: 'Terms & Conditions',
    img: require('../variants/' + BUILD_VARIANT + '/img/icons/new_terms_new_icon.png'),
    img_menu: require('../static/img/icons/dashboard/sml_terms_new_icon.png'),
    route: {name: 'authenticated.terms'},
    dashboard: false,
    active: true
  },
  {
    icon: 'bubble_chart',
    title: 'Logout',
    img: require('../variants/' + BUILD_VARIANT + '/img/icons/new_logout_icon.png'),
    img_menu: require('../static/img/icons/dashboard/sml_logout_icon.png'),
    route: {name: 'unauthenticated.logout'},
    dashboard: false,
    active: true
  }
]
